import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB1ixGWm8CYV6nUWGpkPEbeZEXtHMpL8CI",
  authDomain: "phd-assignment.firebaseapp.com",
  projectId: "phd-assignment",
  storageBucket: "phd-assignment.appspot.com",
  messagingSenderId: "15129475722",
  appId: "1:15129475722:web:315d8e80496a7e18eb4b73",
  measurementId: "G-KJH74LCR7M"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

export { storage };
